import {KTIcon} from '../../../../_metronic/helpers'

const filterNotificationsType = [
  {id: 0, value: 'All', label: 'All'},
  {id: 1, value: 'Success', label: 'Success'},
  {id: 2, value: 'Warning', label: 'Warning'},
  {id: 3, value: 'Danger', label: 'Danger'},
  {id: 4, value: 'Info', label: 'Info'},
]

const NotificationFilter = () => {
  return (
    <>
      {/* begin::Filter Button */}
      <button
        type='button'
        className='btn btn-light-primary me-3 border border-1 border-gray-500'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <KTIcon iconName='filter' className='fs-2' />
        Filter
      </button>
      {/* end::Filter Button */}
      {/* begin::SubMenu */}
      <div
        className='menu menu-sub menu-sub-dropdown w-300px h-400px y-scroll hover-scroll-overlay-y pe-6 me-n6n mt-12'
        data-kt-menu='true'
      >
        {/* begin::Content */}
        <div className='px-7 pt-8 pb-0' data-kt-user-table-filter='form'>
          {/* begin::Input group */}
          <div className='mb-6'>
            <label className='form-label fs-4 fw-bold mb-5'>Status</label>

            <div className=''>
              <div className='form-check form-check-custom form-check-solid mb-4'>
                {/* begin::Input */}
                <input
                  className='form-check-input border border-gray-500 me-3'
                  name='filterStatus'
                  type='checkbox'
                  id='unreadOnly'
                />

                {/* end::Input */}
                {/* begin::Label */}
                <label
                  className='form-check-label fs-5 fw-semibold'
                  htmlFor='unreadOnly'
                  style={{cursor: 'pointer'}}
                >
                  Unread Only
                </label>
              </div>
            </div>
          </div>
          {/* end::Input group */}

          {/* begin::Separator */}
          <div className='separator border-gray-600'></div>
          {/* end::Separator */}

          {/* begin::Input group */}
          <div className='mb-10 mt-5'>
            <label className='form-label fs-4 fw-bold mb-5'>Types</label>

            <div className=''>
              {filterNotificationsType.map((notification) => (
                <div
                  key={notification.id}
                  className='form-check form-check-custom form-check-solid mb-4'
                >
                  {/* begin::Input */}
                  <input
                    className='form-check-input border border-gray-500 me-3'
                    name='filterNotificationsTypes'
                    type='checkbox'
                    value={notification.value}
                    id={notification.value}
                  />

                  {/* end::Input */}
                  {/* begin::Label */}
                  <label
                    className='form-check-label fs-5 fw-semibold'
                    htmlFor={notification.value}
                    style={{cursor: 'pointer'}}
                  >
                    {notification.value}
                  </label>
                </div>
              ))}
            </div>
          </div>
          {/* end::Input group */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::SubMenu */}
    </>
  )
}

export default NotificationFilter
